
import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const transportStore = namespace('transports')

// V3Page is registered globally in App.vue: V3Page indirectly imports the V3Wrappers dialogs, so a local import
// can still be undefined when this module loads
@Component
export default class UnloadingBillDialog extends Vue {
	@transportStore.Action('findRecord')
	findRecord

	@Prop({ required: false, default: true })
	show!: boolean

	@Prop({ required: true })
	transportId!: string

	async syncDocuments() {
		await this.findRecord(this.transportId)

		this.$emit('closing', false)
	}
}
